// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"c537aef0","834":"18479c64"}[chunkId] + ".chunk.js";
};